var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'px-2',
    _vm.light
      ? ("\n    outline " + (_vm.lightNoBorder ? 'outline-0' : 'outline-2') + " outline-green-600\n    text-green-600\n    rounded-md\n    bg-transparent\n    h-8\n    hover:bg-green-600 hover:text-white")
      : "\n    border\n    bg-green-600\n    rounded-md\n    h-10\n    text-white\n    hover:outline-2 hover:outline hover:outline-black\n    ",
    _vm.small ? 'text-sm h-6' : '',
    _vm.icon ? 'mr-2' : '' ],on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',[_vm._t("default")],2),(_vm.icon)?_c('v-icon',{staticClass:"text-green-600",attrs:{"color":"green"}},[_vm._v("mdi-"+_vm._s(_vm.icon))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }